export default __webpack_public_path__ + "media/zurb/img/development-process/style_guide_hero-80118fcfd961244ac326efc282f71a69.png";